export default __webpack_public_path__ + "static/media/primanka.58201923.svg";